import { render } from "./HotelOrderBooking.vue?vue&type=template&id=847d8b64&scoped=true"
import script from "./HotelOrderBooking.vue?vue&type=script&lang=js"
export * from "./HotelOrderBooking.vue?vue&type=script&lang=js"

import "./HotelOrderBooking.vue?vue&type=style&index=0&id=847d8b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847d8b64"]])

export default __exports__